// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import TextFormField, {
    TextFormFieldPresentationProps,
    TextFormFieldProps,
} from "@store/Library/Components/FormField/TextFormField";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { FC } from "react";

export const emailAddressFormFieldLabelKey = "Email Address";

export interface EmailAddressFormFieldPresentationProps extends ExpandStyles<EmailAddressFormFieldStyles> {}

export interface EmailAddressFormFieldProps
    extends Omit<TextFormFieldProps, keyof TextFormFieldPresentationProps>,
        EmailAddressFormFieldPresentationProps {
    prefill?: boolean;
}

export interface EmailAddressFormFieldStyles {
    textFormField?: TextFormFieldPresentationProps;
}

export const emailAddressFormFieldStyles: EmailAddressFormFieldStyles = {};

const EmailAddressFormField: FC<EmailAddressFormFieldProps> = ({
    extendedStyles,
    onValidate,
    overridedStyles,
    prefill,
    prefillValue,
    ...textFormFieldProps
}) => {
    const styles = useExpandProps(emailAddressFormFieldStyles, extendedStyles, overridedStyles);
    const session = useAppSelector(state => state.context.session);

    const validate: typeof onValidate = ({ isValid, value }) => {
        if (!isValid) {
            return;
        }

        let errorMessage: string | undefined;

        if (value && !validateEmail(value)) {
            errorMessage = siteMessage("ContactUsForm_EmailIsInvalidErrorMessage").toString();
        }

        errorMessage = onValidate?.({ isValid: !errorMessage, value }) ?? errorMessage;

        return errorMessage;
    };

    return (
        <TextFormField
            {...styles.textFormField}
            label={translate(`${emailAddressFormFieldLabelKey}`)}
            placeholder={translate("Enter your email address")}
            {...textFormFieldProps}
            onValidate={validate}
            prefillValue={prefill ? session.email : prefillValue}
        />
    );
};

export default EmailAddressFormField;
